module.exports = __webpack_public_path__ + "static/media/checkcircle.0df00891.svg";